import React, { Fragment, useContext, useState } from "react";
import {
	ADD_TO_UNLOCK_REWARD_OPTIONS,
	ADD_TO_UNLOCK_PRODUCTS_PICKER_REDUCER
} from "lib/globals";
import {
	FormGroup,
	FormControl,
	Dropdown,
	ShopifyResourcePicker,
	Button,
	Input,
	ButtonSelect,
	ColorPicker,
	RichEditor,
	Range,
	CustomText,
	Alert,
	Bindings,
	Switch
} from "components";
import styles from "styles/campaign_settings_second_step.module.scss";
import ShopContext from "context/ShopContext";
import PreviewContext from "context/PreviewContext";
import classNames from "lib/classNames";
import { sortByProp } from "components/cart/Utils";
import { SetItemReducer } from "reducers/SetItemReducer";
import { getIn } from "immutable";
import Gift from "./atu_goals/Gift";
import Discount from "./atu_goals/Discount";
import GoalImage from "./atu_goals/GoalImage";
import redeemlyLogo from "assets/redeemly-logo.jpeg";
const AddToUnlock = ({ context, validationErrors, setShowATUAfterText }) => {
	const { state: campaign, setItem } = context;
	const {
		settings: { add_to_unlock },
		target
	} = campaign;
	const { setEditingProductDetails } = useContext(PreviewContext);
	const getError = (key, index) => getIn(validationErrors, ["settings.add_to_unlock.goals", index, key], false);
	const {
		state: {
			currency,
			enabled_presentment_currencies
		}
	} = useContext(ShopContext);
	const [old_add_to_unlock, set_old_add_to_unlock] = useState(add_to_unlock);
	
	return (
		<Fragment>
			<FormGroup
				label="Add To Unlock"
				info={`Create spend goals that will unlock rewards.
				Tip: If you don’t want to add a discount at least create a free shipping goal.
				Note: Discount do not stack on to of each other.
				<a href="https://monsterapps.crisp.help/en/article/add-to-unlock-frequently-bought-together-campaign-1x7xy1r/" target="_blank">(Click to learn more)</a>
				`}
			>
				<FormControl
					label="Enable"
					className="mb-6"
					withSwitch={[context, "settings.add_to_unlock.isActive"]}
				/>
				{add_to_unlock.isActive && (
					<>
						<FormControl error={validationErrors["settings.add_to_unlock.multi_goal_type"]}>
							<ButtonSelect
								options={[
									{
										value: "amount",
										label: "$ Amount in Cart",
										// icon: 'unlock',
										info: "Unlock rewards depending on how much $ are in cart."
									},
									{
										value: "quantity",
										label: "Product Quantity",
										// icon: BOX_CHECK_ICON,
										info: "Unlock reward based on how many products are in the cart."
									}
								]}
								showSeparator={false}
								BindToContext={[
									context,
									"settings.add_to_unlock.multi_goal_type",
									(newValue) => {
										for (const index in add_to_unlock?.goals) {
											const goal = newValue === "quantity" ? 2 + 2 * index : 40 + 20 * index;
											const reward = 10 + 5 * index;
											const hasSpecificGoals = add_to_unlock.goals[index].specific_goals || old_add_to_unlock.goals[index].specific_goals;
											const goalPAth = hasSpecificGoals ? 'specific_goals.0.goal' : 'goal'
											if (newValue === "quantity") {
												setItem(`settings.add_to_unlock.goals.${index}.goal`, goal);
												if (hasSpecificGoals) {
													setItem(`settings.add_to_unlock.goals.${index}.specific_goals`, undefined);
												}
											} else {
												if (hasSpecificGoals) {
													setItem(`settings.add_to_unlock.goals.${index}.specific_goals`, hasSpecificGoals);
													setItem(`settings.add_to_unlock.goals.${index}.goal`, undefined);
												} else {
													setItem(`settings.add_to_unlock.goals.${index}.${goalPAth}`, goal);
												}
											}
											setItem(`settings.add_to_unlock.goals.${index}.discount.reward`, reward);
										}
									}
								]}
							/>
						</FormControl>
						<FormControl
							label="Show all locked goals"
							className="mb-6"
							withSwitch={[context, "settings.add_to_unlock.show_all_locked_goals"]}
						/>
					<div className={classNames('flex items-center mb-3', {
						hidden: add_to_unlock?.goals?.filter(({badge}) => !badge).length !== 0
					})}>
                    	<label className={classNames('text-gray-600 block flex-1 flex-grow capitalize text-sm font-bold')}>Show badges</label>
						<Switch BindToContext={[context, "settings.add_to_unlock.show_badges"]} />
					</div>
						{/* mu-block mu-flex-1 mu-flex-grow mu-capitalize mu-text-sm mu-font-bold mu-text-gray-600  */}
						{add_to_unlock?.goals?.map((goal, index) => {
							const isQuantityGoal = add_to_unlock.multi_goal_type === "quantity"
							const added_currencies = goal.specific_goals?.map(({ currency }) => currency) || []
							const all_currencies_are_selected = enabled_presentment_currencies.filter(currency => !added_currencies.includes(currency)).length === 0
							console.log("goal:");
							console.log(goal);
							return (
								<div key={`goal_${index}`} className={classNames("mb-5 p-4 rounded bg-white relative")}>
									{add_to_unlock.goals.length > 1 && index !== 0 && (
										<Button
											className={classNames(
												"absolute top-0 right-0 -translate-y-1/2 transform translate-x-1/2"
											)}
											icon="times"
											type="circle-danger"
											onClick={() => context.deleteGoal(index)}
										/>
									)}
									<div className={classNames(" font-bold text-gray-600 mb-3")}>
										{`Reward ${index + 1}`}
									</div>


									{(goal.goal || isQuantityGoal) && <FormControl
										label="spend goal"
										info={
											isQuantityGoal
												? "Choose how many products need to be added to the cart to unlock the reward."
												: "Choose what $ amount will need to be added to the cart to unlock the reward."
										}
										className={styles.input}
										error={getError("goal", index)}
									>
										<Input
											type="number"
											BindToContext={[context, `settings.add_to_unlock.goals.${index}.goal`]}
											min={index > 0 ? add_to_unlock.goals[index - 1].goal : 0}
										/>
									</FormControl>}
									{goal.specific_goals && <FormControl label="spend goal"
										isSingleCol
										info={!isQuantityGoal && "Specify goals for multiple currencies. The goal on currencies that are not specified here will be the store default currency goal multiplied by the currency exchange rate determined by Shopify Markets."}
										Footer={!isQuantityGoal ? () => {
											return <div className={classNames("flex justify-end p-2")}>
												<Button beta type="info" text="Specific currency goal" disabled={all_currencies_are_selected} onClick={() => context.newSpecificGoal(index)} icon="plus" />
											</div>
										} : undefined}>
										{!isQuantityGoal && goal.specific_goals?.map((specific_goal, specific_goal_index) => (
											<div className={classNames('flex relative bg-white rounded mb-4')} key={`specific_goal_${specific_goal.currency}`}>
												<FormControl
													label="Currency"
													className='flex-1 mr-2'
													marginBottom="mb-0"
												// error={!!getError('quantity')}
												>
													<Dropdown options={enabled_presentment_currencies.filter(currency => {
														if (specific_goal.main || currency === specific_goal.currency) return true
														return !added_currencies.includes(currency)
													}).map(currency => ({ value: currency, label: currency }))} disabled={specific_goal.main} BindToContext={[context, `settings.add_to_unlock.goals.${index}.specific_goals.${specific_goal_index}.currency`]} />
												</FormControl>
												<FormControl
													label={`Goal in ${specific_goal.currency}`}
													className='flex-1'
													marginBottom="mb-0"
													action={!specific_goal.main && (() => context.removeSpecificGoal(index, specific_goal_index))}
												// error={!!getError('quantity')}
												>
													<Input
														type="number"
														BindToContext={[context, `settings.add_to_unlock.goals.${index}.specific_goals.${specific_goal_index}.goal`]}
														min={index > 0 ? add_to_unlock.goals[index - 1].goal : 0}
													/>
												</FormControl>
											</div>
										))}
										{isQuantityGoal && <Input
											type="number"
											BindToContext={[context, `settings.add_to_unlock.goals.${index}.specific_goals.0.goal`]}
										/>

										}
									</FormControl>}


									<FormControl
										label="Show confetti on unlock"
										info="This will display a celebration when unlock has been achieved."
										hasError={
											!!validationErrors[`settings.add_to_unlock.goals.${index}.confetti`] ||
											!!validationErrors[`settings.add_to_unlock.goals.${index}.confetti_length`]
										}
									>
										<Input
											type="number"
											max={600}
											min={200}
											placeholder="Confetti count"
											BindToContext={[
												context,
												`settings.add_to_unlock.goals.${index}.confetti_length`
											]}
											withSwitch={[context, `settings.add_to_unlock.goals.${index}.confetti`]}
										/>
									</FormControl>

									<FormControl
										label="When goal is reached what will you give them?"
									// error={validationErrors['settings.add_to_unlock.reward_type']}
									>
										<ButtonSelect
											options={ADD_TO_UNLOCK_REWARD_OPTIONS(add_to_unlock.goals, index)}
											keyPrefix={`settings.add_to_unlock.goals.${index}.reward_type`}
											BindToContext={[
												context,
												`settings.add_to_unlock.goals.${index}.reward_type`,
												(newValue) => {
													if (newValue === "free_shipping") {
														setItem(
															`settings.add_to_unlock.goals.${index}.goal_text.text`,
															"Free Shipping"
														);
													} else if (newValue === "discount") {
														const { type, reward } = add_to_unlock.goals[index].discount;
														const text =
															type === "percentage"
																? `${reward}% Off`
																: `${currency} ${reward} Off`;
														setItem(
															`settings.add_to_unlock.goals.${index}.goal_text.text`,
															text
														);
													}
													else if (newValue === "gift") {
														setItem(
															`settings.add_to_unlock.goals.${index}.goal_text.text`,
															"Free Gift"
														);
													}
												}
											]}
											first
										/>
									</FormControl>
									{goal.reward_type === "manual" && (
										<div className={classNames("mt-4 mb-6")}>
											<div className={classNames("flex items-start")}>
												<span className={classNames("font-medium text-sm")}>Store credit / cashback is in partnership with Shopify App</span>
												<img src={redeemlyLogo} style={{
													height: 24,
													// width: 96
												}} className={classNames("ml-2")} />
												<span className={classNames("ml-2 flex-center bg-orange-500 tracking-wider py-1 px-2 rounded-lg text-white text-xxs font-bold")}>Beta</span>
											</div>
											<a 
											href="https://monsterapps.crisp.help/en/article/store-credits-monster-cart-redeemly-guide-1pott89/" 
											target="_blank" 
											rel="noopener noreferrer" 
											className={classNames("text-blue-600 hover:text-blue-800 underline font-medium text-sm")}
											>
												Learn how to set this up here
											</a>
										</div>
									)}
									<GoalImage goal={goal} index={index} 
									show_badges={!!goal.badge && add_to_unlock.show_badges}
									context={context}
									setBadgeType={(selected) => setItem(`settings.add_to_unlock.goals.${index}.badge.type`, selected)} 
									setBadgeImage={(selected) => setItem(`settings.add_to_unlock.goals.${index}.badge.image`, selected)} 
									/>
									<CustomText
										className={add_to_unlock.show_badges ? 'hidden': ''}
										withSwitch={[context, `settings.add_to_unlock.goals.${index}.show_goal_text`]}
										context={context}
										label="Goal text"
										path={`settings.add_to_unlock.goals.${index}.goal_text`}
										text={add_to_unlock.goals[index].goal_text.text}
										hasColor={true}
									/>
									{
										goal.reward_type === "free_shipping" && (
											<Fragment>
												<FormControl
													label="text before hitting the goal"
													info="We recommend using emoji's to draw attention"
													// error={validationErrors['settings.add_to_unlock.free_shipping.before']}
													isSingleCol
												>
													<RichEditor
														imageEmoji={true}
														BindToContext={[
															context,
															`settings.add_to_unlock.goals.${index}.free_shipping.before`
														]}
														placeholder="add {{amount}} to unlock free shipping !"
													// hasError={!!validationErrors['settings.add_to_unlock.free_shipping.before']}
													/>
													<Bindings only={["goal", "amount_left"]} />
												</FormControl>
												<FormControl
													label="text after hitting the goal"
													info="We recommend using emoji's to draw attention. (You can leave this blank.)"
													// error={validationErrors['settings.add_to_unlock.discount.after']}
													isSingleCol
												>
													<RichEditor
														imageEmoji={true}
														// onFocus={() => setShowATUAfterText(true)}
														// onBlur={() => setShowATUAfterText(false)}
														// hasError={!!validationErrors['settings.add_to_unlock.discount.after']}
														// BindToContext={[context, 'settings.add_to_unlock.discount.after']}
														BindToContext={[
															context,
															`settings.add_to_unlock.goals.${index}.free_shipping.after`
														]}
														placeholder="you've unlocked {{reward}} off"
													/>
													<Bindings />
												</FormControl>
											</Fragment>
										)
									}
									{
										goal.reward_type === "discount" && (
											<Discount {...{ campaign, context, currency, index, validationErrors, styles }} />
										)
									}
									{
										goal.reward_type === "manual" && (
											<Fragment>
												<FormControl
													label="text before hitting the goal"
													info="We recommend using emoji's to draw attention"
													// error={validationErrors['settings.add_to_unlock.free_shipping.before']}
													isSingleCol
												>
													<RichEditor
														imageEmoji={true}
														BindToContext={[
															context,
															`settings.add_to_unlock.goals.${index}.manual.before`
														]}
														placeholder="add {{amount}} to unlock free shipping !"
													// hasError={!!validationErrors['settings.add_to_unlock.free_shipping.before']}
													/>
													<Bindings only={["goal", "amount_left"]} />
												</FormControl>
												<FormControl
													label="text after hitting the goal"
													info="We recommend using emoji's to draw attention. (You can leave this blank.)"
													// error={validationErrors['settings.add_to_unlock.discount.after']}
													isSingleCol
												>
													<RichEditor
														imageEmoji={true}
														BindToContext={[
															context,
															`settings.add_to_unlock.goals.${index}.manual.after`
														]}
														placeholder="you've unlocked {{reward}} off"
													/>
													<Bindings />
												</FormControl>
											</Fragment>
										)
									}
									{goal.reward_type === "gift" && <Gift  {...{ context, index, validationErrors }} />}
								</div>
							);
						})}
						<FormControl>
							<div>
								<Button
									text={
										add_to_unlock?.goals?.length < 4
											? "+ Add another reward"
											: "Only 4 rewards are available"
									}
									onClick={() => {
										context.newGoal();
										if (add_to_unlock.goals[0].show_goal_text === false) {
											setItem("settings.add_to_unlock.goals.0.show_goal_text", true);
										}
									}}
									style={{ width: "100%" }}
									disabled={add_to_unlock?.goals?.length >= 4}
								/>
							</div>
						</FormControl>
						<FormControl>
							<Alert type="info" icon="info-circle" title="campaign summary">
								{add_to_unlock?.goals?.map((campaignGoal, currentIndex) => (
									<Summary
										{...{
											key: `atu_summary_${currentIndex}`,
											campaignGoal,
											target,
											goals: add_to_unlock.goals,
											currentIndex,
											currency,
											multi_goal_type: add_to_unlock.multi_goal_type
										}}
									/>
								))}
							</Alert>
						</FormControl>
						<FormControl label="Progress bar thickness">
							<ButtonSelect
								options={[
									{
										label: "Thin",
										value: false,
									},
									{
										label: "Thick",
										value: true,
									}
								]}
								BindToContext={[context, "settings.add_to_unlock.progress_thick"]}
							/>
						</FormControl>
						<FormControl label="Progress bar colors">
							<ColorPicker
								text="Primary"
								BindToContext={[context, "settings.add_to_unlock.progress_primary"]}
							/>
							<ColorPicker
								text="Secondary"
								BindToContext={[context, "settings.add_to_unlock.progress_secondary"]}
							/>
							<ColorPicker
								text="Goal complete"
								BindToContext={[context, "settings.add_to_unlock.progress_complete"]}
							/>
							<ColorPicker
								text="Background"
								BindToContext={[context, "settings.add_to_unlock.progress_background"]}
							/>
						</FormControl>
					</>
				)}
			</FormGroup>
			<FormGroup label="Frequently bought Together">
				<FormControl
					label="Enable"
					className="mb-6"
					withSwitch={[context, "settings.add_to_unlock.show_suggestions"]}
				/>
				{!!campaign.settings.add_to_unlock.show_suggestions && (
					<>
						<FormControl
							label="products to suggest"
							info="Suggest products that are likely to be added. We recommend choosing products that are easy to understand without learning more."
							error={validationErrors["settings.add_to_unlock.products"]}
							isSingleCol={true}
						>
							<div className={classNames("mb-4")}>
								<ButtonSelect
									isVertical={false}
									options={[
										{
											label: "Specific Products",
											value: "custom_recommendation",
											// infoHtml: true,
											info: `When you want very specific products to appear depending on what is in the cart`
										},
										{
											label: "Shopify Recomendations",
											value: "shopify_recommendation",
											// infoHtml: true,
											info: ` Use Shopify’s powerful machine learning to suggest commonly purchased products or products in related collections.`
										}
									]}
									BindToContext={[context, "settings.add_to_unlock.recommendation_type"]}
								/>
							</div>

							{campaign.settings.add_to_unlock.recommendation_type === "custom_recommendation" && (
								// (
								// 	!campaign.settings.add_to_unlock.recommendation_type ||
								// 	campaign.settings.add_to_unlock.recommendation_type === "custom_recommendation"
								// ) &&
								<ShopifyResourcePicker
									BindToContext={[context, "settings.add_to_unlock.products"]}
									reducer={ADD_TO_UNLOCK_PRODUCTS_PICKER_REDUCER}
								>
									{(trigger) => {
										return (
											<>
												<Button
													text="Select Products"
													type={
														validationErrors["settings.add_to_unlock.products"] &&
															!!validationErrors["settings.add_to_unlock.products"][0]
															? "danger"
															: "primary"
													}
													onClick={trigger}
													style={{
														width: "100%"
													}}
												/>
												{!!campaign.settings.add_to_unlock.show_suggestions &&
													!campaign.settings.add_to_unlock.products.length && (
														<p
															className={classNames(
																"text-center text-gray-500 text-xs italic mt-2"
															)}
														>
															Select a product to expand more settings
														</p>
													)}
											</>
										);
									}}
								</ShopifyResourcePicker>
							)}
						</FormControl>
						{campaign.settings.add_to_unlock.recommendation_type === "shopify_recommendation" && (
							<div className={classNames("mb-4")}>
								<Alert type="info" icon="info-circle" title="Please note">
									<p>Products in preview cart have been randomly selected.</p>
								</Alert>
							</div>
						)}

						{campaign.settings.add_to_unlock.recommendation_type === "shopify_recommendation" && (
							<>
								<FormControl label="Number of products displayed">
									<Range
										BindToContext={[context, "settings.add_to_unlock.products_length"]}
										min={1}
										max={5}
									/>
								</FormControl>
								<FormControl label="Exclusion tags" info="Hide products with these tags">
									<Dropdown
										isCreatable={true}
										isMulti={true}
										BindToContext={[context, "settings.add_to_unlock.exclude_tags"]}
									/>
								</FormControl>
							</>
						)}

						<FormControl
							label="Separator"
							info="This separator can help you communicate your suggested products. It disappears when no suggested products are available."
							error={
								validationErrors["settings.add_to_unlock.separator.text"] ||
								validationErrors["settings.add_to_unlock.separator.active"]
							}
						>
							<Input
								placeholder="Or"
								BindToContext={[context, "settings.add_to_unlock.separator.text"]}
								withSwitch={[context, "settings.add_to_unlock.separator.active"]}
							/>
						</FormControl>

						<div className={classNames("flex")}>
							<FormControl
								className={classNames("flex-1 mr-2")}
								label="Background color"
								// info="Header background color"
							>
								<ColorPicker BindToContext={[context, "settings.add_to_unlock.background"]} />
							</FormControl>
							<FormControl className={classNames("flex-1")} label="Border color"
								// info="Box border color"
							>
								<ColorPicker BindToContext={[context, "settings.add_to_unlock.borderColor"]} />
							</FormControl>
						</div>

						<CustomText
							label="Title"
							placeholder="Frequently Bought Together"
							hasColor={true}
							context={context}
							path="settings.add_to_unlock.title"
							hasWeight="600"
						/>
						<CustomText
							label="Show Product Details"
							placeholder="Show Details"
							hasColor={true}
							context={context}
							path="settings.add_to_unlock.show_product_details"
							hasWeight="600"
						/>
						<CustomText
							label="Add To Cart Button"
							placeholder="Add To Cart"
							hasColor={true}
							context={context}
							path="settings.add_to_unlock.upsell_add_button"
							hasWeight="600"
						/>
						<CustomText
							label="Confirm Button"
							placeholder="Confirm"
							context={context}
							path="settings.add_to_unlock.upsell_confirm_button"
							hasWeight="600"
						/>
						<CustomText
							label="Product title"
							context={context}
							hasColor={true}
							path="settings.add_to_unlock.product_title"
							hasWeight="600"
						/>
						<CustomText
							label="Product Price"
							placeholder="Confirm"
							context={context}
							hasColor={true}
							path="settings.add_to_unlock.product_price"
							hasWeight="600"
						/>
						{/* <FormControl
							label="Display above checkout"
							className="mb-4"
							withSwitch={[context, "settings.add_to_unlock.fbt_below"]}
						/> */}
          				<FormControl label="Display">
							<Dropdown
								options={[
									{ value: "under_products", label: "Under products" },
									{ value: "above_checkout", label: "Above checkout" },
									{ value: "below_checkout", label: "Below checkout" },
								]}
								BindToContext={[
									context,
									"settings.add_to_unlock.fbt_position"
								]}
							/>
		  				</FormControl>
					</>
				)}
			</FormGroup>

			{/* from settings  */}
			{
				!!campaign.settings.add_to_unlock.show_suggestions && (
					// (!!campaign.settings.add_to_unlock.products.length ||
					// 	campaign.settings.add_to_unlock.recommendation_type === "shopify_recommendation" )
					// &&
					<FormGroup
						label="show details"
						info={`This is used when someone clicks read more on campaigns.
							Tip: If you have a long descriptions make the read more button send users straight to the product page for a better experience.`}
						onFocus={() => setEditingProductDetails(true)}
						onBlur={() => setEditingProductDetails(false)}
						focusCondition={({ event }) => {
							const productDetails = document.getElementById("monster_product_details");
							return productDetails
								? productDetails === event.target || productDetails.contains(event.target)
								: false;
						}}
					>
						<CustomText
							// onFocus={() => setEditingProductDetails(true)}
							// onBlur={() => setEditingProductDetails(false)}
							context={context}
							label="Add to cart button"
							path="settings.add_to_unlock.product_details.atcButton"
							hasColor={true}
							hasWeight="700"
						/>
						<FormControl label="add to cart button colors">
							<ColorPicker
								// onFocus={() => setEditingProductDetails(true)}
								// onBlur={() => setEditingProductDetails(false)}
								text="Background"
								BindToContext={[context, "settings.add_to_unlock.product_details.atcButton_background"]}
							/>
							{/* <ColorPicker
							// onFocus={() => setEditingProductDetails(true)}
							// onBlur={() => setEditingProductDetails(false)}
							text="hover background"
							BindToContext={[
								context,
								"settings.add_to_unlock.product_details.atcButton_hoverBackground"
							]}
						/> */}
						</FormControl>
						<FormControl label="Limit product description length">
							<Input
								// onFocus={() => setEditingProductDetails(true)}
								// onBlur={() => setEditingProductDetails(false)}
								type="number"
								placeholder="Characters length"
								BindToContext={[context, "settings.add_to_unlock.product_details.truncate_length"]}
								withSwitch={[context, "settings.add_to_unlock.product_details.truncate"]}
							/>
						</FormControl>
						<CustomText
							// onFocus={() => setEditingProductDetails(true)}
							// onBlur={() => setEditingProductDetails(false)}
							context={context}
							label="Read more button"
							path="settings.add_to_unlock.product_details.readMore"
							hasColor={true}
							hasWeight="700"
						/>
						<FormControl error={validationErrors["settings.add_to_unlock.product_details.external"]}>
							<ButtonSelect
								options={[
									{ label: "Open product page", value: true },
									{ label: "Expand description", value: false }
								]}
								BindToContext={[context, "settings.add_to_unlock.product_details.external"]}
							/>
						</FormControl>
					</FormGroup>
				)
			}
		</Fragment >
	);
};

export default AddToUnlock;

const Summary = ({ campaignGoal, target, goals, currentIndex, currency, multi_goal_type }) => {
	const { reward_type, goal, goal_type } = campaignGoal;
	const rewardType = campaignGoal[reward_type];
	const isDiscount = reward_type === "discount";
	const isGift = reward_type === "gift";
	const { type, reward } = rewardType;
	//TODO: i need show money formatting here
	let free_shipping_text = "";
	if (isDiscount) {
		//check if the previous goals has free shipping
		const sortedGoalsAsc = sortByProp("goal", "asc")(goals);
		const previousGoals = [...goals].splice(0, currentIndex);
		const hasFreeShipping = !!previousGoals.find((goal) => goal.reward_type === "free_shipping");
		if (hasFreeShipping) {
			free_shipping_text = "Free Shipping + ";
		}
	}

	if (
		(target.type === "specific_products" && !target.selected.length) ||
		(!!isDiscount && !type) ||
		!goal ||
		!goal_type ||
		(!!isDiscount && !reward)
	) {
		return null;
	}
	// const must_truncated = (text) => text.length > 25;
	// const truncate_name = (text) => `"${text.substring(0, 25).trim()}${must_truncated(text) ? "..." : ""}"`;
	// const product_name = target.type === "specific_products" ? truncate_name(target.selected[0].title) : "any product";
	const formatter_reward = isDiscount
		? type === "percentage"
			? `${reward}%  off`
			: `$${reward}  off`
		: isGift ? "a Free Gift" : "Free Shipping";

	if (multi_goal_type === "amount") {
		return (
			<p
				className={classNames("mb-2")}
			>{`Spend ${currency} ${goal}+ and get ${free_shipping_text}${formatter_reward}.`}</p>
		);
	} else if (multi_goal_type === "quantity") {
		return (
			<p
				className={classNames("mb-2")}
			>{`Buy ${goal} products and get ${free_shipping_text}${formatter_reward}.`}</p>
		);
	}
};
